/* eslint-disable react/prop-types */
import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { notNull } from "../../../utils/helper";
import { convertDateTimeToDate } from "../../../utils/dateAndTime";
import OrganizationStructureBlock from "../../../components/OSBlock/OSBlock";

const styles = {
  text: {
    fontSize: 11,
  },
  expandedTextHeading: {
    fontSize: 10,
    color: "#171B5E",
  },
  expandedText: {
    fontSize: 10,
  },
  column: { width: "9.5%" },
  column2: { width: "12.5%" },
  link: {
    color: "#0000FF",
    cursor: "pointer",
  },
  iconSize: { fontSize: 14 },
};

function IntroductionRemark({ data }) {
  return (
    <Box>
      <Grid container style={{ padding: 10 }}>
        <Grid item style={styles.column2}>
          <Typography style={styles.expandedTextHeading}>
            Name & Address
          </Typography>
          <Typography style={styles.expandedText}>
            {notNull(data.fullName)}
          </Typography>
          <Typography style={styles.expandedText}>
            {notNull(data.addressLine1)}
          </Typography>
        </Grid>
        <Grid item style={styles.column2}>
          <Typography style={styles.expandedTextHeading}>
            Phone & Email
          </Typography>
          <Typography style={styles.expandedText}>
            {notNull(data.mobileNumber)}
          </Typography>
          <Typography style={styles.expandedText}>
            {notNull(data.emailId)}
          </Typography>
        </Grid>
        <Grid item style={styles.column2}>
          <Typography style={styles.expandedTextHeading}>
            Division & Subdivision
          </Typography>
          <Typography style={styles.expandedText}>
            {notNull(data.divisionName)}
          </Typography>
          <Typography style={styles.expandedText}>
            {notNull(data.subDivisionName)}
          </Typography>
        </Grid>
        <Grid item style={styles.column2}>
          <Typography style={styles.expandedTextHeading}>
            Initiator Name
          </Typography>
          <Typography style={styles.expandedText}>
            {notNull(data.initiatorMember?.fullName)}
          </Typography>
          <Typography style={styles.expandedText}>
            {notNull(data.initiatorMember?.mobileNumber)}
          </Typography>
        </Grid>
        <Grid item style={{ width: "50%" }}>
          <Typography style={styles.expandedTextHeading}>
            Initiating Organization Structure
          </Typography>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item md={11}>
              <OrganizationStructureBlock
                type="default"
                data={{
                  area: data.initiatorMember.areaName,
                  cluster: data.initiatorMember.clusterName,
                  zone: data.initiatorMember.zoneName,
                  region: data.initiatorMember.regionName,
                  chapter: data.initiatorMember.chapterName,
                  district: data.initiatorMember.districtName,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container style={{ backgroundColor: "#f2f2f2", padding: 10 }}>
        <Grid item md={6} xs={6}>
          <Grid container>
            <Grid item md={3} xs={3}>
              <Typography style={styles.expandedTextHeading}>
                Initiate Date
              </Typography>
              <Typography style={styles.expandedText}>
                {convertDateTimeToDate(data.createdAt)}
              </Typography>
            </Grid>
            <Grid item md={3} xs={3}>
              <Typography style={styles.expandedTextHeading}>
                Last Update
              </Typography>
              <Typography style={styles.expandedText}>
                {convertDateTimeToDate(data.updatedAt)}
              </Typography>
            </Grid>
            <Grid item md={3} xs={3}>
              <Typography style={styles.expandedTextHeading}>
                Introducer
              </Typography>
              <Typography style={styles.expandedText}>
                {data.introducedByName}
              </Typography>
              <Typography style={styles.expandedText}>
                {data.introducedByMobileNumber}
              </Typography>
            </Grid>
            <Grid item md={3} xs={3}>
              <Typography style={styles.expandedTextHeading}>
                Target SI
              </Typography>
              <Typography style={styles.expandedText}>
                {data.targetSiName}
              </Typography>
              <Typography style={styles.expandedText}>
                {data.targetSiMobileNumber}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={6} xs={6}>
          <Typography style={styles.expandedTextHeading}>
            Target Organization Structure
          </Typography>
          <Grid container style={{ marginTop: 5 }}>
            <Grid item md={11}>
              <OrganizationStructureBlock
                type="target"
                data={{
                  area: data.targetOrganizationStructure.targetOrgArea,
                  cluster: data.targetOrganizationStructure.targetOrgCluster,
                  zone: data.targetOrganizationStructure.targetOrgZone,
                  region: data.targetOrganizationStructure.targetOrgRegion,
                  chapter: data.targetOrganizationStructure.targetOrgChapter,
                  district: data.targetOrganizationStructure.targetOrgDistrict,
                }}
              />
            </Grid>
            <Grid item />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default IntroductionRemark;
